import Nav from "../Nav/Nav";
import { Link } from "react-router-dom";
import { useState } from "react";
import globe from '../../Assets/Background/globe.svg'
import logo from "../../Assets/Logo/lipana.svg";
import lightLogo from "../../Assets/Logo/lipana.png";
import Logos from "../Logos/Logos";
import GridAnimation from "../GridAnimation/Grid";
import { Button } from "@mui/material";
import { lipana_signup } from "../../Config/redirect_url";
import image from "../../Assets/hero.png";
import { AiFillPlayCircle } from "react-icons/ai";
import { useEffect, useRef } from "react";

const Hero2 = () => {
  const [sticky, setSticky] = useState("#");

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 100) {
        return setSticky("sticky");
      } else {
        return setSticky("#");
      }
    });
  }

  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <section className="bg-[#010f24] relative  overflow-hidden pb-16">
      <div className="absolute w-full h-full left-0 top-0 bg-transparent">
        <GridAnimation />
      </div>
      <div
        className={`z-50 w-full fixed top-0 ${
          sticky === "sticky"
            ? `w-full bg-[#f8f7f4] text-blackColor`
            : `text-white`
        }`}
      >
        <Nav logo={sticky === "#" ? lightLogo : logo} />
      </div>
      <div className="relative px-6 mx-auto max-w-6xl mt-32 md:mt-32 md:pb-16 xl:px-0">
        <div className="flex flex-col w-full space-y-10 md:items-center md:space-y-0 md:flex-row">
          <div className="text-white space-y-3 mx-auto md:w-3/4">
            <h1 className="text-3xl font-semibold lg:leading-[3.5rem] lg:text-5xl">
              Internet payments
              <span className="text-lipanaOrange block">
                Built for developers , <br /> by developers
              </span>
            </h1>
            <h4 className="md:hidden">
              Create a free account with Lipana, accept payments online, run
              subscriptions, collect donations in seconds and grow your
              business.
            </h4>
            <h4 className="hidden text-lg w-3/4 md:block">
              Create a free account with Lipana, accept payments online, run
              subscriptions, collect donations in seconds and grow your
              business.
            </h4>
            <div className="flex flex-col !mt-8 gap-y-6 md:flex-row md:gap-8">
              <Button
                variant="contained"
                color="primary"
                size="large"
                className="!rounded-full !font-semibold !py-2 !capitalize !bg-brandColor"
              >
                <Link to={lipana_signup()}>Create free account</Link>
              </Button>
              <Button
                variant="outlined"
                className="!text-brandColor !border-brandColor !rounded-full !capitalize !text-[14px] !py-2 !font-semibold"
              >
                <Link to="/contact">Contact Sales</Link>
              </Button>
            </div>
          </div>
          <div>
            <img src={globe} alt="" />
          </div>
        </div>
      </div>
     <div className="max-w-6xl mx-auto">
     <h2 className="text-center text-white text-xl font-semibold md:text-2xl md:leading-[3.4rem]">
          Trusted by hundreds of businesses
        </h2>
        <div className="mt-5 md:mt-10">
          <Logos />
        </div>
        <div className="relative w-full mt-16 md:mt-32">
          <img
            src={image}
            alt=""
            className="h-64 w-full rounded-[20px] md:h-auto brightness-[95%]"
          />
          <div className="absolute top-0 left-0 w-full h-full flex flex-row items-center justify-center">
            <AiFillPlayCircle
              className="cursor-pointer text-brandColor text-6xl md:text-8xl hover:text-lipanaOrange duration-300"
              onClick={() => setIsOpen(!isOpen)}
            />
          </div>

          <div
            ref={ref}
            className={`${
              isOpen ? `visible` : `hidden`
            } absolute top-0 left-0 w-full`}
          >
            <iframe
              className="w-full h-[300px] lg:h-[755px]"
              src="https://www.youtube.com/embed/qbUEcMNZ8CU"
              title="How to Create an Invoice with Lipana"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              muted={!isOpen}
            ></iframe>
          </div>
        </div>
     </div>
    </section>
  );
};

export default Hero2;
